module.exports = __webpack_public_path__ + "img/A_customer_xing.6fc31469.png";